import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { request } from '../../common';
import type { HeaderApiResponse } from './header-api.type';

export const HeaderApiPath = '/headerfooter/header';

export type UseHeaderApiOptions = Omit<
  UseQueryOptions<HeaderApiResponse, unknown, HeaderApiResponse, [string]>,
  'queryKey' | 'queryFn'
>;

export function useHeaderApi(options?: UseHeaderApiOptions) {
  return useQuery({
    queryKey: ['header'],
    queryFn: async () => {
      const response = await request<HeaderApiResponse>({
        method: 'get',
        url: HeaderApiPath,
        devHost: true,
      });
      return response;
    },
    ...options,
  });
}
